module.exports = __webpack_public_path__ + "img/sql.d82132f1.png";